import { render, staticRenderFns } from "./evaluaciones_laborantes.vue?vue&type=template&id=a566da9c"
import script from "./evaluaciones_laborantes.vue?vue&type=script&lang=js"
export * from "./evaluaciones_laborantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports